import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Inject, Renderer2, DOCUMENT } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { App } from '@df/core/app';
import { Client } from '@df/core/service/client';
@Component({
    selector: 'app',
    styles: [
        `
            :host {
                height: inherit;
            }
        `
    ],
    template: `<router-outlet></router-outlet>`,
    standalone: true,
    imports: [RouterOutlet],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent {
    private initiated = false;

    constructor(
        private client: Client,
        app: App,
        elementRef: ElementRef<HTMLElement>,
        @Inject(DOCUMENT) private document: Document,
        // private changeDetectorRef: ChangeDetectorRef,
        // private router: Router,
        private renderer2: Renderer2
    ) {
        app.hasSSRCode = (elementRef.nativeElement as HTMLElement).hasAttribute('ng-server-context');
        client.isCms$.subscribe(isCms => {
            if (isCms) {
                this.setAsRoot(elementRef.nativeElement);
            } else {
                this.setAsRoot((this.document.scrollingElement || this.document.body) as HTMLElement);
            }
        });
    }
    // ngOnInit() {
    //     this.router.events.subscribe(event => {
    //         if (event instanceof NavigationEnd) {
    //             // this.applicationRef.tick();
    //             this.detectChanges();
    //         }
    //     });
    //     this.initiated = true;
    // }

    private setAsRoot(element: HTMLElement) {
        const currentRoot = this.client.getRootElement();
        if (currentRoot !== element) {
            if (currentRoot) {
                this.renderer2.removeClass(currentRoot, 'appRoot');
            }
            // appRoot class is set in global.scss
            this.renderer2.addClass(element, 'appRoot');
            this.client.setRootElement(element);
        }
    }
    // private detectChanges() {
    //     if (this.initiated) {
    //         this.changeDetectorRef.detectChanges();
    //     }
    // }
}
